import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { auth } from './firebase';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UserChatsPage from './pages/UserChatsPage';
import UserDetailsPage from './pages/UserDetailsPage';
import UserRatingsPage from './pages/UserRatingsPage';
import UserReferralsPage from './pages/UserReferralsPage';
import PrivateRoute from './components/PrivateRoute';

// Create a theme instance
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

function App() {
  // Set up auth state listener for debugging
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log('User is signed in:', user.uid);
      } else {
        console.log('User is signed out');
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/dashboard/user/:userId" 
            element={
              <PrivateRoute>
                <UserDetailsPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/dashboard/user/:userId/chats" 
            element={
              <PrivateRoute>
                <UserChatsPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/dashboard/user/:userId/ratings" 
            element={
              <PrivateRoute>
                <UserRatingsPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/dashboard/user/:userId/referrals" 
            element={
              <PrivateRoute>
                <UserReferralsPage />
              </PrivateRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
